import { Folder } from '@opengov/bnp-component-folders/src';

export type FoldersAndReportsQueryParams = {
  entityId?: number;
  parentFolderId?: Folder['id'];
  limit: number;
  offset?: number;
  sort?: Record<string, string> | null;
  filter?: Record<string, string> | null;
};

export const foldersAndReportsQueryKeys = {
  all: ['foldersAndReports'] as const,
  withQueryParams: ({ entityId, parentFolderId, limit, offset = 0, sort, filter }: FoldersAndReportsQueryParams) =>
    [...foldersAndReportsQueryKeys.all, entityId, parentFolderId, limit, offset, sort, filter] as const
};
